import { LockeClientId } from '../types';
import { isLockeAuthenticated } from './authenticationService';
import { decodeLmdstok, decodeUserCookie } from '../user';

export const isTokenExpired = (exp: number): boolean => {
  return exp < Date.now() / 1000;
};

export const isUserSignedIn = async (
  token: string | undefined,
  oldToken: string | undefined,
  lockeClientId: LockeClientId,
): Promise<boolean> => {
  if (
    token &&
    (await isAuthenticatedWithDecodedCookie(token, oldToken, lockeClientId))
  ) {
    return true;
  }

  if (
    oldToken &&
    (await isAuthenticatedWithDecodedJwt(oldToken, lockeClientId))
  ) {
    return true;
  }
  return false;
};

const isAuthenticatedWithDecodedCookie = async (
  token: string,
  oldToken: string | undefined,
  lockeClientId: LockeClientId,
): Promise<boolean> => {
  const decodedCookie = decodeUserCookie(token);
  if (!decodedCookie) {
    return false;
  }

  const { lockeId, expiry } = decodedCookie;
  return await isTokenAuthenticated(oldToken, lockeClientId, lockeId, expiry);
};

const isAuthenticatedWithDecodedJwt = async (
  oldToken: string,
  lockeClientId: LockeClientId,
): Promise<boolean> => {
  const decodedJwt = decodeLmdstok(oldToken);
  if (!decodedJwt) {
    return false;
  }

  const { expiry, lockeId } = decodedJwt;
  return await isTokenAuthenticated(oldToken, lockeClientId, lockeId, expiry);
};

const isTokenAuthenticated = async (
  token: string | undefined,
  lockeClientId: LockeClientId,
  lockeId: string,
  expiry: number,
): Promise<boolean> => {
  if (!lockeId || !expiry) {
    return false;
  }

  if (isTokenExpired(expiry)) {
    return await isLockeAuthenticated(token, lockeClientId);
  }
  return true;
};
